import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PasswordRecoveryForm from './pages/PasswordRecoveryForm';
import PasswordSuccess      from './pages/PasswordSuccess';
import LinkExpired          from './pages/LinkExpired';
import GenericError         from './pages/GenericError';
import PdfDownload          from './pages/PdfDownload';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/password-recovery/view"          element={<PasswordRecoveryForm />} />
        <Route path="/pdf-download/view"               element={<PdfDownload />} />
        <Route path="/success"                         element={<PasswordSuccess />} />
        <Route path="/error/link-expired"              element={<LinkExpired />} />
        <Route path="/error/generic"                   element={<GenericError />} />
        <Route path="*" element={<Navigate to="/error/link-expired" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
